// This is the main function where which pass two ref parameters of Parent element & Child element
export const scrollIntoView = (parent: Element, child: Element, substrahendElement: Element | null = null, isSmartScroll: boolean = true) => {

    const clientBounding = child.getBoundingClientRect();
    let substrahendBouning;
    let clientTop = clientBounding.top;
    let clientBottom = clientBounding.bottom;

    if (substrahendElement) {
        substrahendBouning = substrahendElement.getBoundingClientRect();
        clientTop = clientTop - substrahendBouning.height;
        clientBottom = clientBottom - substrahendBouning.height;
    }

    const parentBounding = parent.getBoundingClientRect();
    const parentBottom = parentBounding.bottom;
    const parentTop = parentBounding.top;

    if (!isSmartScroll) {
        scrollTo(parent, clientTop, 0);
        return;
    }

    if (parentTop >= clientTop || clientBottom > parentBottom) {
        scrollTo(parent, -(parentTop - clientTop), 300);
    }
};

export const scrollToStep = (stepIndex: number) => {
    const stepId = `step-${stepIndex}`;
    const headerElement = document.getElementById('app-header');
    scrollIntoView(document.body, document.getElementById(stepId)!, headerElement!, false);
}

function scrollTo(element: Element, to: number, duration: number = 0) {
    if (duration === 0){
        element.scrollTop = to;
        return;
    }

    const start = element.scrollTop;
    let currentTime = 0;
    const increment = 20;

    const animateScroll = function () {
        currentTime += increment;

        const val = easeInOutQuad(currentTime, start, to, duration);
        element.scrollTop = val;

        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };

    animateScroll();
}
// Function for smooth scroll animation with the time duration
function easeInOutQuad(time: number, startPos: number, endPos: number, duration: number) {
    time /= duration / 2;

    if (time < 1) {
        return (endPos / 2) * time * time + startPos;
    }
    time--;
    return (-endPos / 2) * (time * (time - 2) - 1) + startPos;
}